import CrudAPI from '@/api/resources/crud'

const categoriesAPI = {
  // specific categories api
  resource: 'categories',

  loadCategories () {
    return new Promise((resolve, reject) => {
      let categories = CrudAPI.dfsResourceIndex(this.resource)

      categories.then(result => {
        result.forEach((item, i) => {
          item.text = item.name
          item.value = item.id
        })

        resolve(result)
      }, error => {
        reject(error)
      })
    })
  },

  storeCategory (name) {
    return new Promise((resolve, reject) => {
      let categories = CrudAPI.dfsResourceStore(this.resource, {
        name: name
      })

      categories.then(result => {
        resolve(result)
      }, error => {
        reject(error)
      })
    })
  },

  editCategory (categoryId, payload) {
    return new Promise((resolve, reject) => {
      let result = CrudAPI.dfsResourceUpdate(this.resource, categoryId, payload)

      result.then(result => {
        resolve(result !== undefined ? result.data.additional_data : null)
      })
    })
  }
}

export default categoriesAPI



// WEBPACK FOOTER //
// ./src/api/resources/categories.js